(()=>{
const $=id=>document.getElementById(id),rm=matchMedia('(prefers-reduced-motion:reduce)').matches;
const m=$('m'),l=$('l'),w=$('w'),ey=$('eye');
addEventListener('mousemove',e=>{
 if(m&&!rm){const x=e.clientX/innerWidth-.5,y=e.clientY/innerHeight-.5;
  m.style.transform=`rotate(${-2+x*3}deg) translate(${x*-24}px,${y*-14}px)`;
  if(l)l.style.transform=`rotate(${6-x*4}deg) translate(${x*28}px,${y*20}px)`;
  if(w)w.style.transform=`translateY(${y*-30}px)`}
 if(ey){ey.style.left=e.clientX+'px';ey.style.top=e.clientY+'px'}});
if(m&&ey){m.onmouseenter=()=>ey.style.opacity=1;m.onmouseleave=()=>ey.style.opacity=0}
// song select
const items=[...document.querySelectorAll('#menu li')];let i=0;
function pick(n){i=(n+items.length)%items.length;items.forEach((e,k)=>{e.classList.toggle('on',k==i);e.setAttribute('aria-selected',k==i)});
 const e=items[i];$('nt').textContent=e.dataset.t+(e.dataset.y?' / '+e.dataset.y:'');$('cv').textContent=e.dataset.c;$('nl').href=e.dataset.u||'#'}
if(items.length){items.forEach((e,k)=>{e.onmouseenter=()=>pick(k);   e.onclick=()=>{pick(k);if(e.dataset.u)window.open(e.dataset.u,'_blank','noopener')}});
 $('menu').onkeydown=e=>{if(e.key=='ArrowDown'){e.preventDefault();pick(i+1)}if(e.key=='ArrowUp'){e.preventDefault();pick(i-1)}}}
// draggable window
const win=$('win'),h=$('wh');
if(win&&h){let d=null,ox=0,oy=0;
 h.onpointerdown=e=>{d=[e.clientX-ox,e.clientY-oy];h.setPointerCapture(e.pointerId);h.style.cursor='grabbing'};
 h.onpointermove=e=>{if(d){ox=e.clientX-d[0];oy=e.clientY-d[1];win.style.transform=`translate(${ox}px,${oy}px)`}};
 h.onpointerup=()=>{d=null;h.style.cursor='grab'};
 const msg=(win.dataset.msgs||'no').split('|').filter(Boolean);let c=0;
 $('n1').onclick=()=>{$('wm').textContent=win.dataset.yes||'ok'};
 $('n2').onclick=()=>{$('wm').textContent=msg[c++%msg.length]}}
(()=>{const f=document.querySelector('#m img');if(f&&!document.querySelector('#m .bgb')){f.classList.add('fg');const b=f.cloneNode();b.className='bgb';b.alt='';b.setAttribute('aria-hidden','true');b.removeAttribute('fetchpriority');f.parentNode.insertBefore(b,f)}})();
const vc=$('vc');if(vc)vc.textContent=String(400+Math.floor(Math.random()*90)).padStart(6,'0');
})();
